<div class="content-wrapper auth-wrapper">
  <mat-card class="content mat-elevation-z4">
    <router-outlet></router-outlet>
  </mat-card>
</div>

<div class="ad" *ngIf="showAd()">
  <iframe src="https://elements.cloud/login-page" frameborder="0"></iframe>
</div>
